// extracted by css-extract-rspack-plugin
export default {"mobileWrapper":"mobile-wrapper--rCaRAvfJo7ijviNX"};